const styles = theme => ({
  root: {
    marginTop: 12,
    marginBottom: 12
  },
  exp: {
    height: 62,
    [theme.breakpoints.up('sm')]: {
      height: 50
    },
    [theme.breakpoints.up('md')]: {
      height: 50
    }
  },
  rowDetails: {},
  heading: {
    width: 'calc(45%)'
  },
  filterButton: {
    backgroundColor: 'rgba(233, 243, 253, 1.0)'
  },
  deleteButton: {
    backgroundColor: 'rgba(233, 243, 253, 1.0)',
    width: 50
  },
  button: {
    fontSize: 12,
    marginTop: 0,
    marginLeft: 'calc(100% - 195px)',
    paddingLeft: 27,
    position: 'absolute',
    backgroundColor: 'rgba(233, 243, 253, 1.0)',
    [theme.breakpoints.up('sm')]: {
      fontSize: 12,
      marginTop: -8,
      marginLeft: 'calc(100% - 195px)',
      paddingLeft: 27,
      position: 'absolute'
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 12,
      marginTop: -8,
      marginLeft: 'calc(100% - 195px)',
      paddingLeft: 27,
      position: 'absolute'
    }
  },
  emptySpace: {
    marginBottom: 6
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/components/Row/styles.js